/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-21 10:18:29
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-01-27 11:23:04
 * @FilePath: \crm-product\found\views\tpm\views\activity\group_purchase_outbound_reporting\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import ModalList from '../components/modal_list.vue';
import barCodeList from '../components/codes.vue';

formCreate.component('barCodeList', barCodeList);
formCreate.component('ModalList', ModalList);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'main_form',
      formParentCode: 'CRM20260121000000002',
      rule: [],
      buttonText: {
        submit: '暂存',
        close: '关闭',
        submitAudit: '提交',
      },
      buttons: {
        submitAudit: true,
      },
    };
  },
  created() {},
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'customerName') { // 选择产品
        v.props = {
          ...v.props,
          params: {
            functionCode: 'customer_list',
            paramData: {
              userName: JSON.parse(localStorage.getItem('userInfo')).userName,
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'productName') { // 选择产品
        v.props = {
          ...v.props,
          params: {
            functionCode: 'product_list',
            paramData: {
              customerCode: '',
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'fileList') {
        v.props = {
          ...v.props,
          showFileList: true,
          uploadType: 'file',
          listType: 'text',
          fileMsg: '只能上传pdf,docx,xlsx,ppt,png,jpg,jpeg等类型',
          accept: '.pdf,.doc,.docx,.xlsx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.jpeg',
        };
      }
      return v;
    },
    async formComplete() {
      const customerName = this.getRule('customerName');
      const productName = this.getRule('productName');
      const boxList = this.getRule('barCodeList');

      customerName.on.change = (e) => {
        if (e && e.length) {
          this.setValue({
            customerName: e[0].customerName,
            customerCode: e[0].customerCode,
            productName: '',
            productCode: '',
          });
          productName.props.params.paramData.customerCode = e[0].customerCode;
        } else {
          this.setValue({
            customerName: '',
            customerCode: '',
            productName: '',
            productCode: '',
          });
          productName.props.params.paramData.customerCode = '';
        }
        boxList.props = {
          ...boxList.props,
          customerCode: e && e.length > 0 ? e[0].customerCode : null,
        };
        boxList.value = [];
      };
      productName.on.change = (e) => {
        if (e && e.length > 0) {
          this.setValue({
            productName: e[0].productName,
            productCode: e[0].productCode,
          });
        } else {
          this.setValue({
            productName: '',
            productCode: '',
          });
        }
        boxList.props = {
          ...boxList.props,
          productCode: e && e.length > 0 ? e[0].productCode : null,
        };
        boxList.value = [];
      };
      if (this.formConfig.code === 'view' || this.formConfig.code === 'edit') {
        await this.init();
      }
    },

    // 提交
    async submit(type) {
      let params = this.getFormData();
      const {
        row,
        code,
      } = this.formConfig;
      if (!params) return false;
      let url = '/cps/v1/groupBuyingOutboundPerformance/create';
      params = {
        ...params,
        isSubmit: type === 1 ? 'N' : 'Y',
      };
      if (code === 'edit') {
        url = '/cps/v1/groupBuyingOutboundPerformance/update';
        params = {
          ...params,
          id: row.id,
          reportRecordCode: row.reportRecordCode,
        };
      }
      if (type === 2) {
        this.$confirm('请核对信息是否填写正确，一经提交信息将无法进行修改，是否确认提交?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            request.post(url, params).then((res) => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '提交成功',
                });
                this.$emit('onClose');
                this.$emit('onGetList');
              }
            });
          });
      } else {
        const {
          success,
        } = await request.post(url, params);
        if (success) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.$emit('onClose');
          this.$emit('onGetList');
        }
      }
    },

    async init() {
      const {
        row,
      } = this.formConfig;
      const data = await request.get('/cps/v1/groupBuyingOutboundPerformance/findById', {
        id: row.id,
      }).then((res) => (res.success ? res.result : {}));
      const productName = this.getRule('productName');
      const boxList = this.getRule('barCodeList');
      productName.props.params.paramData.customerCode = data.customerCode;
      boxList.props = {
        ...boxList.props,
        productCode: data.productCode,
        customerCode: data.customerCode,
      };
      this.setValue(data);
    },
  },
};
